import { getLocation } from '@weathernews/btos-javascript-modules/src/wniutil/gps.js'

export class CustomLocationControl {
  onAdd(map) {
    this._map = map
    this._container = document.createElement('div')
    this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group'

    if (!document.querySelector('#custom-geolocate-style')) {
      const style = document.createElement('style')
      style.id = 'custom-geolocate-style'
      style.textContent = `
        .custom-geolocate-icon {
          background-image: url('https://gvs.weathernews.jp/onebox/radar/img/icon/icon_search_off.svg');
          background-position: 50%;
          background-repeat: no-repeat;
          display: block;
          height: 100%;
          width: 100%;
        }
        .custom-geolocate-icon.active {
          background-image: url('https://gvs.weathernews.jp/onebox/radar/img/icon/icon_search_on.svg');
        }
      `
      document.head.append(style)
    }

    // ボタンをインスタンスのプロパティとして保持
    this._button = document.createElement('button')
    this._button.className = 'maplibregl-ctrl-geolocate'
    this._button.type = 'button'
    this._button.title = 'Find my location'
    this._button.setAttribute('aria-label', 'Find my location')
    this._button.setAttribute('aria-pressed', 'false')

    const iconSpan = document.createElement('span')
    iconSpan.className = 'custom-geolocate-icon'
    iconSpan.setAttribute('aria-hidden', 'true')
    this._button.append(iconSpan)

    this._button.addEventListener('click', () => this.locate())
    this._container.append(this._button)
    return this._container
  }

  async locate() {
    const iconSpan = this._button.querySelector('.custom-geolocate-icon')
    try {
      const { lat, lon } = await getLocation()
      if (iconSpan) iconSpan.classList.add('active')
      // ピンをGeoJSONで表示
      if (this._map.getSource('user-location')) {
        this._map.getSource('user-location').setData({
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: { type: 'Point', coordinates: [lon, lat] }
            }
          ]
        })
      }
      // 必要ならイベント発火
      window.dispatchEvent(new Event('custom-geolocate'))
      // 地図中心を現在地に移動
      this._map.flyTo({ center: [lon, lat], zoom: 11 })
    } catch (e) {
      if (iconSpan) iconSpan.classList.remove('active')
      console.error('位置情報の取得に失敗しました', e)
    }
  }

  onRemove() {
    this._container.remove()
    this._map = undefined
  }
}
